// Single source of truth for the "Reply in Messages" action on a client workout/exercise comment.
// Stages a quoted-reply snapshot that the CoachMessages composer picks up on mount (sessionStorage key
// `stp_reply_ctx_<client_id>`), then the caller navigates to the client's Messages tab. Never auto-sends.
// Shared by coach Notifications and Training History so both produce an identical reply experience.
export function stageWorkoutCommentReply({ client_id, kind, text, workout_name, exercise_name, date, log_id }) {
  if (!client_id) return false;
  const snapshot = {
    message_id: null,
    sender: 'client',
    kind: kind || 'workout_comment',
    preview: (text || '').slice(0, 200),
    context: {
      workout_name: workout_name || null,
      exercise_name: exercise_name || null,
      date: date || null,
      log_id: log_id || null,
    },
  };
  try { sessionStorage.setItem(`stp_reply_ctx_${client_id}`, JSON.stringify(snapshot)); } catch { /* ignore */ }
  return true;
}
